import React from "react";
import { MDBBox, MDBBtn } from "mdbreact";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";

import back from "assets/images/icons/back.svg";
import logo from "assets/images/logo/logo1.png";
import { useLogout } from "hooks/useLogout";
import { slide as MobileMenu } from "react-burger-menu";
import { useHistory, useLocation } from "react-router";
import { Nav } from "reactstrap";

import logout from "assets/images/icons/login-box-fill.png";

import NewDrawer from "pages/configuration/newDrawer";
import NotificationsBell from "components/NotificationsBell/NotificationsBell";
import "./Header.scss";

import { Avatar } from "antd";
import Hamburger from "assets/images/icons/hamburger.png";
import { useSelector, useDispatch } from "react-redux";
import { setSidebarStatus } from "actions/user";
import DefaultImage from "assets/images/user.png";
import { extractImageFromZip } from "helpers/extractImageFromZip";
import { eventTrack } from "helpers/ga4Helper";
import CompanyPicker from "components/CompanyPicker/CompanyPicker";
import CompanyLogo from "components/CompanyLogo/CompanyLogo";
import { getMyCompanies } from "api/companyMembership/companyMembership";

var styles = {
  bmBurgerButton: {
    position: "absolute",
    width: "20px",
    height: "16px",
    top: "25%",
    right: "20px",
  },
  bmBurgerBars: {
    background: "#000000",
  },
  bmBurgerBarsHover: {
    background: "#a90000",
  },
  bmCrossButton: {
    height: "50px",
    width: "50px",
    top: "20px",
    right: "10px",
  },
  bmCross: {
    background: "#000000",
  },
  bmMenuWrap: {
    position: "fixed",
    height: "100%", //vh
    top: "0px",
  },
  bmMenu: {
    background: "#fff",
    padding: "23px",
    fontSize: "1.15em",
  },
  bmMorphShape: {
    fill: "#373a47",
  },
  bmItemList: {
    color: "black !important",
    padding: "0em",
  },
  bmItem: {
    display: "inline-block",
    listStyle: "none",
    paddingTop: "10px !important",
  },
  bmOverlay: {
    background: "rgba(0, 0, 0, 0.6)",
    opacity: 1,
    width: "100%",
  },
};

const Header = (props) => {
  const [show, setShow] = useState(false);
  const logOut = useLogout();
  const history = useHistory();
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const userInfoRedux = useSelector((s) => s.user.userInfo);
  const sidebarStatusRedux = useSelector((s) => s.user.sidebar);

  const [initialUrl, setInitialUrl] = useState("");
  const [profilePic, setProfilePic] = useState(null);

  const location = useLocation();

  const learning = location.pathname.startsWith("/learning");

  useEffect(() => {
    setInitialUrl(pathname);
  }, []);

  useEffect(() => {
    (async () => {
      const extractedImg = await extractImageFromZip(
        userInfoRedux?.profilePhoto
      );
      setProfilePic(extractedImg);
    })();
  }, [userInfoRedux]);

  const { setModal, anonymous } = props;

  // People in more than one company get a switch next to their name.
  // Everybody else gets nothing new: one row means no control at all.
  const [companies, setCompanies] = useState([]);
  const [pickerOpen, setPickerOpen] = useState(false);
  const signedInId = userInfoRedux?.id;
  const activeCompanyId = userInfoRedux?.company;
  useEffect(() => {
    if (anonymous || !signedInId) {
      setCompanies([]);
      return undefined;
    }
    let alive = true;
    getMyCompanies()
      .then((r) => { if (alive) setCompanies((r && r.memberships) || []); })
      .catch(() => { if (alive) setCompanies([]); });
    return () => { alive = false; };
  }, [anonymous, signedInId, activeCompanyId]);
  // Every signed-in person sees the company they are working in, with its
  // logo (initials when it has none) - owner 2026-10-11: "every company
  // logo file is visible when they have an account". The row comes from
  // /company-membership/mine (live: a logo set a minute ago shows), and the
  // session's own claims stand in while that loads or if it fails.
  // People in more than one company can click it to switch.
  const activeCompany = companies.find((c) => c.active) || (
    userInfoRedux?.companyName || userInfoRedux?.logo
      ? { companyName: userInfoRedux?.companyName || "", logo: userInfoRedux?.logo || "" }
      : null
  );
  const canSwitch = companies.length >= 2;
  const companyLabel = activeCompany?.companyName || "Company";
  // A partner firm works inside its sponsor's account (owner, 2026-10-12:
  // BES "see BidLight account not DP account, they are partners of DP").
  // The server names the sponsor on the membership row; it is shown beside
  // the partner's own logo so the account they are in is never left to the
  // product logo to answer.
  // Every enterprise account they work for, when there are several.
  const sponsors = (activeCompany?.sponsors?.length ? activeCompany.sponsors : [activeCompany?.sponsor]).filter((x) => x?.companyName);
  const sponsor = sponsors.length ? { ...sponsors[0], companyName: sponsors.map((x) => x.companyName).join(", ") } : null;
  const sponsorTag = sponsor ? (
    <span
      className="d-flex align-items-center ml-2 header-company-sponsor"
      title={`${companyLabel} - partner of ${sponsor.companyName}`}
      data-testid="header-company-sponsor"
    >
      <span className="pr-1 small text-muted">Partner of</span>
      {sponsors.map((x) => (
        <span key={x.company || x.companyName} className="d-flex align-items-center mr-1">
          <CompanyLogo logo={x.logo} name={x.companyName} size={22} />
          <span className="ml-1 small header-company-sponsor-name">{x.companyName}</span>
        </span>
      ))}
    </span>
  ) : null;
  const companyChip = !anonymous && signedInId && activeCompany ? (
    canSwitch ? (
      <MDBBtn
        color=""
        className="header-btn bg-white border-bid text-bid shadow-none pl-2 mr-2 d-flex align-items-center"
        title={`Switch company - ${companyLabel}`}
        onClick={() => setPickerOpen(true)}
      >
        <CompanyLogo logo={activeCompany.logo} name={companyLabel} size={26} />
        <span className="ml-2 pr-2 header-company-name">{companyLabel}</span>
        {sponsorTag}
      </MDBBtn>
    ) : (
      <div className="d-flex align-items-center mr-3" title={sponsor ? `${companyLabel} - partner of ${sponsor.companyName}` : companyLabel} data-testid="header-company">
        <CompanyLogo logo={activeCompany.logo} name={companyLabel} size={32} />
        {sponsorTag}
      </div>
    )
  ) : null;
  const handleLogout = () => {
    logOut();
    history.push("/");
  };

  const navigateToLogin = () => {
    history.push("/authorization");
  };

  const HeaderComp = () => {
    return (
      <>
        <div
          className="d-flex align-items-center cursor-pointer header-profile-icon desktop-show"
          onClick={() => {
            history.push("/profile")
            {
              eventTrack(
                "Profile-Navigation-Action",
                "Profile-Navigation",
                userInfoRedux?.name,
                "+1",
                false,
                "+1"
              );
            }
            
          }}
        >
          <img
            src={profilePic || DefaultImage}
            onError={(e) => (e.target.src = DefaultImage)}
          />
          <p className="mb-0 font-weight-600 f-16 text-black ml-2 roboto">
            {userInfoRedux?.name ?? "Guest"}
          </p>
        </div>

        <div className="vr mr-3 ml-5"></div>
        {learning && (
          <div className="learning-container-flex">
            <MDBBtn
              className="header-btn bg-white border-bid text-bid shadow-none pl-4"
              color=""
              onClick={() => {
                history.push("/learning");
              }}
            >
              <i className="fa fa-question f-15" />
              <span className="ml-3 pr-2">FAQ</span>
            </MDBBtn>

            <MDBBtn
              className="header-btn bg-white border-bid text-bid shadow-none pl-4"
              color=""
              onClick={() => {
                history.push("/learning/articles")
                {
                  eventTrack(
                    "Articles-Navigation-Action",
                    "Articles-Navigation",
                    userInfoRedux?.name,
                    "+1",
                    false,
                    "+1"
                  );
                }
              }}
            >
              <i className="fa fa-book f-15" />
              <span className="ml-3 pr-2">Articles</span>
            </MDBBtn>
          </div>
        )}

        {pathname !== "/dashboard" && (
          <MDBBtn
            color=""
            id="backButton"
            className="header-btn bg-bid border-bid text-white shadow-none pl-4 desktop-show"
            onClick={() => {
              history.goBack();
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="7"
              height="12"
              viewBox="0 0 7 12"
              fill="none"
            >
              <path
                d="M5.66087 0.827637L0.488281 6.00025L5.66087 11.1728L6.83937 9.99433L2.84528 6.00025L6.83937 2.00614L5.66087 0.827637Z"
                fill="white"
              />
            </svg>
            <span className="ml-3 pr-2">Back</span>
          </MDBBtn>
        )}

        {anonymous ? (
          <MDBBtn
            onClick={() => navigateToLogin()}
            color=""
            className="header-btn border-bid text-bid shadow-none pl-3"
          >
            <img src={logout} />
            <span>Login</span>
          </MDBBtn>
        ) : (
          <MDBBtn
            onClick={handleLogout}
            color=""
            className="header-btn border-bid text-bid shadow-none pl-3"
          >
            <img src={logout} />
            <span>Logout</span>
          </MDBBtn>
        )}
      </>
    );
  };

  const MobileHeaderComp = () => {
    return (
      <>
        <div
          className="d-flex align-items-center cursor-pointer header-profile-icon desktop-show"
          onClick={() => {
            history.push("/profile");
          }}
        >
          <img
            src={profilePic || DefaultImage}
            onError={(e) => (e.target.src = DefaultImage)}
          />
          <p className="mb-0 font-weight-600 f-16 text-black ml-2 roboto">
            {userInfoRedux?.name ?? "Guest"}
          </p>
        </div>

        <div className="mobile-sidebar-btngroup">
          <div>
          {companyChip}
          {learning && (
            <div className="learning-container-flex">
              <MDBBtn
                color=""
                onClick={() => {
                  history.push("/learning")
                  {
                    eventTrack(
                      "FAQ-Navigation-Action",
                      "FAQ-Navigation",
                      userInfoRedux?.name,
                      "+1",
                      false,
                      "+1"
                    );
                  }
                }}
              >
                <i className="fa fa-question f-15" />
                <span className="ml-3 pr-2">FAQ</span>
              </MDBBtn>

              <MDBBtn
                color=""
                onClick={() => {
                  history.push("/learning/articles");
                  {
                    eventTrack(
                      "Articles-Navigation-Action",
                      "Articles-Navigation",
                      userInfoRedux?.name,
                      "+1",
                      false,
                      "+1"
                    );
                  }
                }}
              >
                <i className="fa fa-book f-15" />
                <span className="ml-3 pr-2">Articles</span>
              </MDBBtn>
            </div>
          )}

          {pathname !== "/dashboard" && (
            <MDBBtn
              color=""
              onClick={() => {
                history.goBack();
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="7"
                height="12"
                viewBox="0 0 7 12"
                fill="none"
              >
                <path
                  d="M5.66087 0.827637L0.488281 6.00025L5.66087 11.1728L6.83937 9.99433L2.84528 6.00025L6.83937 2.00614L5.66087 0.827637Z"
                  fill="white"
                />
              </svg>
              <span className="ml-3 pr-2">Back</span>
            </MDBBtn>
          )}

          {anonymous ? (
            <MDBBtn onClick={() => navigateToLogin()} color="">
              <img src={logout} />
              <span>Login</span>
            </MDBBtn>
          ) : (
            <MDBBtn onClick={handleLogout} color="">
              <img src={logout} />
              <span className="ml-3 pr-2">Logout</span>
            </MDBBtn>
          )}
          </div>
        </div>
      </>
    );
  };

  return (
    <>
      <NewDrawer
        open={sidebarStatusRedux}
        // setOpen={setOpen}
        anonymous={anonymous}
        setModal={setModal}
      />
      {/* Not sticky by itself: AppTopBars (App.jsx) pins the header and the
          Coordination tab strip together, so nothing slides between them. */}
      <MDBBox className="header centerMargin">
        <MDBBox className="custom-container align-items-center ">
          <span className="d-flex align-items-center header-left">
            <div className="hamburger-div">
              <img
                src={Hamburger}
                className="w-20px cursor-pointer"
                onClick={() => dispatch(setSidebarStatus(true))}
              />
            </div>
            <img
              src={logo}
              className="header-logo "
              onClick={() => history.push("/dashboard")}
            />

            <div className="btn-tool-group mt-1 desktop-show">
              <button
                onClick={() => {
                  setModal("DownloadSoftware");
                }}
                className="bg-bid px-3 mr-0"
              >
                <i className="fa fa-download mr-2"></i>
                BidLight 3.0
              </button>
            </div>
            {/* The company switch sits on the LEFT, right after the download
                button (owner, 2026-10-12: "move the drop down at the top to
                change organizations to left after the download button").
                Desktop only here; the mobile menu keeps its own copy. */}
            {companyChip ? (
              <div className="header-company-left desktop-show ml-3" data-testid="header-company-left">
                {companyChip}
              </div>
            ) : null}
          </span>
          <MDBBox className="justify-content-between align-items-center header-content desktop-show">
            <div className="d-flex align-items-center">
              {/* Bell lives OUTSIDE HeaderComp: HeaderComp is an inline
                  component type re-created every render, so anything
                  inside it remounts constantly (see App.jsx note). */}
              {!anonymous && <NotificationsBell />}
              <HeaderComp />
            </div>
          </MDBBox>
        </MDBBox>

        <Nav className="ml-auto pr-3 mobile-show navDropToggle" navbar>
          <MobileMenu width="70%" right styles={styles}>
            <MobileHeaderComp />
          </MobileMenu>
        </Nav>
      </MDBBox>
      {/* Outside HeaderComp for the same reason as the bell above. */}
      {companies.length >= 2 ? (
        <CompanyPicker
          open={pickerOpen}
          memberships={companies}
          onStay={() => setPickerOpen(false)}
          onCancel={() => setPickerOpen(false)}
        />
      ) : null}
    </>
  );
};

Header.propTypes = {
  setModal: PropTypes.func,
};

export default Header;
